'use strict';
import notificationService from 'services/notificationService';

export default (store) => {
  return (to, from, next) => {
    if (to.meta.requiresLoggedIn && !store.getters['auth/loggedIn']) {
      next('/login');
    } else if (to.meta.requiresSomeRole && !store.getters['auth/hasSomeRole'](to.meta.requiresSomeRole)) {
      notificationService.error('error.auth.invalid');
    } else {
      next()
    }
  }
};



// WEBPACK FOOTER //
// ./client/router/hooks/routerAuthHook.js